import React, { useMemo, useState } from "react";
import {
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Typography,
  useTheme,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { useHistory } from "react-router-dom";
import { useAnalyticsDispatch } from "../../context/analytics";
import Modal from "./Modal";
import FieldFilters from "../header/FieldFilters";
import { useFieldsFiltersState } from "../../context/field-filters";
import { useFieldsState } from "../../context/fields";
import { fieldNameSorter } from "../../helpers/sorting";

const useStyles = makeStyles((theme) => ({
  root: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  modalHeader: {
    backgroundColor: theme.palette.primary.main,
  },
  modalTitle: {
    color: "#fff",
    marginBottom: theme.spacing(1),
  },
  modalContent: {
    padding: 0,
  },
}));

function FieldNavLink({ children, current, fields }) {
  const history = useHistory();
  const [modalOpen, setModalOpen] = useState(false);
  const { farm, crop_type, valve_group } = useFieldsFiltersState();
  const { fields: contextFields } = useFieldsState();
  const dispatch = useAnalyticsDispatch();
  const theme = useTheme();
  const classes = useStyles();

  // Use fields from the fields context (loaded fresh by the dashboard) when
  // available, falling back to the auth-context client.fields prop.
  const availableFields = contextFields?.length ? contextFields : fields;

  const filteredFields = useMemo(
    () =>
      availableFields?.length
        ? availableFields
            .filter(
              (item) =>
                item.id !== current &&
                (farm === "" || farm === item.farm) &&
                (crop_type === "" || crop_type === item.crop_type) &&
                (valve_group === "" || valve_group === item.valve_group)
            )
            .sort(fieldNameSorter)
        : [],
    [availableFields, current, farm, crop_type, valve_group]
  );

  const switchField = (id) => {
    dispatch({ type: "setActiveField", payload: null });
    history.push(`/field/${id}`);
  };

  return (
    <>
      <span className={classes.root} onClick={() => setModalOpen(!modalOpen)}>
        {children}
        <KeyboardArrowDownIcon fontSize="small" color="disabled" />
      </span>
      <Modal open={modalOpen} closeable={true}>
        <Card>
          <CardContent className={classes.modalHeader}>
            <Typography variant="h3" className={classes.modalTitle}>
              Switch to another field:
            </Typography>
            <FieldFilters
              fields={availableFields}
              color={theme.palette.secondary.main}
            />
          </CardContent>
          <CardContent className={classes.modalContent}>
            {filteredFields.length ? (
              <List style={{ maxHeight: "60vh", overflow: "auto" }}>
                {filteredFields.map(({ id, name, crop_type, farm }) => (
                  <ListItem
                    key={`field_link-${id}`}
                    onClick={() => switchField(id)}
                    style={{ cursor: "pointer" }}
                  >
                    <ListItemText
                      secondary={`${farm ? farm : "n/a"} | ${
                        crop_type ? crop_type : "n/a"
                      }`}
                    >
                      {name} {farm} {crop_type}
                    </ListItemText>
                  </ListItem>
                ))}
              </List>
            ) : (
              <Typography variant="body2">No fields found.</Typography>
            )}
          </CardContent>
        </Card>
      </Modal>
    </>
  );
}

export default FieldNavLink;
